import axios from "axios";
import { setLoader } from "../reusable_components/Loader";


async function fetchData(url, errorHandler, cb, useGlobalLoader = true) {
    if (useGlobalLoader) {
        setLoader(true)
    }
    try {
        const token = window.localStorage.getItem('fm_token');
        const headers = { authorization: `bearer ${token}` };
        const { data } = await axios.get(url, { headers });
        
        if(cb !== null && cb !== undefined) {
            cb(data)
        } else {
            return data
        }
    } catch (error) {
        errorHandler(error)
    } finally {
        if (useGlobalLoader) {
            setLoader(false)
        }
    }
}

export default fetchData;